import { useState, useEffect } from 'react';
import { supabase } from '../services/supabaseClient';
import { useAuth } from '../context/AuthContext';

/** Load sensor intelligence contexts for the current user (sensor_id -> row). */
export function useSensorContexts() {
  const { user } = useAuth();
  const [sensorContexts, setSensorContexts] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setSensorContexts({});
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('sensor_contexts')
          .select('*')
          .eq('user_id', user.id);

        if (cancelled) return;

        if (error) {
          setSensorContexts({});
        } else {
          const map = {};
          (data || []).forEach((row) => {
            map[row.sensor_id] = row;
          });
          setSensorContexts(map);
        }
      } catch {
        if (!cancelled) setSensorContexts({});
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { sensorContexts, isLoading };
}
